import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { PageList, ENUM_FORM_DISPLAY } from "../../components/pageList";
import ActionCellRender from "../../components/actionCellRender";
import { IconPencil, IconCircleCheck } from "@tabler/icons";
import { useServerApi } from "../../hooks/userServerApi";
import { useTabNavigate } from "../../hooks/useTabNavigate";
import { mcaProcessColumns } from "../../components/mca/mcaTableHelpers";

const apiEntity = "mcaProcess";

const formSchema = {
  title: "Approval Process",
  apiEntity,
  display: {
    mode: ENUM_FORM_DISPLAY.MODAL,
    size: "sm",
  },
  initialValues: { name: "" },
  layout: {
    fields: [],
  },
};

const McaProcess = () => {
  const navigate = useNavigate();
  const [api] = useServerApi();
  const tabNav = useTabNavigate();

  const listActions = useMemo(
    () => [
      {
        label: "New Process",
        onClick: () => navigate("/management/mcaProcess/new"),
        requiresWrite: true,
      },
    ],
    [navigate]
  );

  const tableSchema = useMemo(
    () => ({
      columns: [
        ...mcaProcessColumns(),
        {
          cellRender: ActionCellRender,
          isAction: true,
          actions: [
            { name: "edit", label: "Edit", icon: IconPencil },
            { name: "toggle", label: "Toggle active", icon: IconCircleCheck },
          ],
        },
      ],
      onActionBtnClickCustom: async ({ action, data, fetchData }) => {
        if (action === "edit") {
          tabNav.open({
            pathname: `/management/mcaProcess/${data._id}`,
            label: data.name
              ? `MCA - ${data.name}`
              : data.code
                ? `MCA - ${data.code}`
                : "MCA - Approval Process",
          });
          return;
        }
        if (action === "toggle") {
          const res = await api.Mca.toggleStatus(data._id);
          if (res?.success) {
            toast.success(
              data.status === "ACTIVE" ? "Process deactivated" : "Process activated"
            );
            fetchData?.();
          }
        }
      },
    }),
    [api, tabNav]
  );

  return (
    <PageList
      apiEntity={apiEntity}
      title="Approval Process"
      formSchema={formSchema}
      showAddButton={false}
      customActions={listActions}
      tableSchema={tableSchema}
      initSort={{ by: "createdAt", order: "desc" }}
    />
  );
};

export default McaProcess;
